// extracted by mini-css-extract-plugin
export default {"backdrop":"errorModal_backdrop__9D5Vw","modal-overlay":"errorModal_modal-overlay__5vz+k","modal-message":"errorModal_modal-message__AqeoM"};